import { Box, Stack, Typography } from "@mui/material";

interface DetalleGeneracionContractualesProps {
    props: any;
}

export const DetalleGeneracionContractuales = (props: DetalleGeneracionContractualesProps) => {
    return (
        <Box ml={2} mr={4} mt={4} mb={2}>
            <Typography>Errores reportados:</Typography>
            <Stack>
                {props.props.map((detail: any, idx: any) => (
                    <Typography key={idx}>{detail}</Typography>
                ))}
            </Stack>
        </Box>
    );
};
